import styled from "styled-components"

export const PageWrapper = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
`
